import { ButtonPropTypes } from '../Button/propTypes';

export const DataClearFiltersPropTypes = ButtonPropTypes;
